import { Ingredient } from "../../types/ingredient";

type Props = {
    ingredients: Ingredient[],
    backgroundClass: string,
    title: string
};

const Ingredients = ({
    ingredients,
    backgroundClass,
    title,
}: Props) => (
    <section id="ingredients">
        <div className={`container-fluid ${backgroundClass} text-white align-items-center`}>
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-8 text-center fs-3 fw-bold py-4" dangerouslySetInnerHTML={{ __html: title }}></div>
            </div>
            <div className="row px-5 mt-4 justify-content-center">
                <div className="col-xxl-6 col-md-8">
                    <div className="row">
                        {ingredients.map((ingredient, index) => (
                            <div className="col-lg-4 col-6 text-center mb-5" key={index}>
                                <picture>
                                    <source srcSet={ingredient.imgWebp} type="image/webp" />
                                    <img className="img-fluid gg-img-ingredient mb-2" src={ingredient.img} loading="lazy"/>
                                </picture>                                
                                <div className="fw-bold">{ingredient.name}</div>
                                <div>{ingredient.benefit}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Ingredients;